<template>
  <section class="section small-padding">
    <div class="container">
      <div class="row">
          <div class="col-md-6">
            <h2>Campañas</h2>
          </div>
          <div class="col-md-6 text-right">
              <router-link to="/campaigns/new" style="margin-top: 1em;" class="btn btn-fill">Nueva</router-link>
          </div>
      </div>     
      <div class="panel-group">
        <div class="row">
                                  <div class="col-md-12 text-center" v-if="loading">
                                    <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                  </div>
                                  <div v-if="!loading&&campaigns.length==0" class="text-center">
                                    <h2>No hay campañas</h2>
                                  </div>
        </div>
        <div>
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Fecha Creacion</th>
              <th>Fecha Inicio</th>
              <th>Activa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(camp,idx) in campaigns">
              <td>
                <router-link class="text-brand" :to="`/campaigns/edit/${camp._id}`"><label style="cursor:pointer;">{{camp.name}}</label></router-link>
              </td>
              <td>{{camp.fechaCreacion | formatearFecha}}</td>
              <td>{{camp.fechaInicio | formatearFecha}}</td>
              <td>
                <span class="label btn-info" style="cursor:pointer;" @click="verSucursales(camp)">Sucursales</span>                
                <span class="label label-success" v-if="camp.activo">Activa</span>
                <span class="label btn-brand" style="cursor:pointer;" @click="finalizarCampaign(camp)" v-if="camp.activo">Finalizar campaña</span>                
                <span v-if="!camp.activo">
                  <span class="label label-danger" v-if="yaComenzo(camp.fechaInicio)">
                    Inactiva
                  </span>
                  <span v-else>
                    <span class="label label-warning">
                      Inicia {{camp.fechaInicio | fromNow }}
                    </span>
                    <span class="label btn-brand" style="cursor:pointer; margin-left:2px;" @click="cancelarCampaign(camp)">Cancelar campaña</span>                
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        </div>     
      </div>
    </div>

    <div class="modal" ref="modalSucursales" role="dialog">
      <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">Sucursales</h4>
                </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-4 col-sm-4" v-for="suc in sucursales">
                          {{suc.denominacion}} - {{suc.empresa.razonSocial}}
                      </div>
                    </div>
                  </div>
            </div>
      </div>
    </div>

  </section>
</template>
<script>
import moment from 'moment'
import swal from 'sweetalert2'
import $ from 'jquery'

moment.locale('es')

export default {
  computed: {
  },
  data () {
    return {
      sucursales: [],
      campaigns: [],
      page: 0,
      offset: 0,
      loading: false
    }
  },
  filters: {
    formatearFecha (value) {
      return moment(new Date(value)).format('DD/MM/YYYY')
    },
    fromNow (value) {
      return moment(new Date(value)).fromNow()
    }
  },
  methods: {
    yaComenzo (value) {
      return moment(new Date(value)).isBefore(moment())
    },
    verSucursales (camp) {
      const me = this
      console.log(camp)
      me.sucursales = camp.sucursales
      $(me.$refs.modalSucursales).modal()
    },
    finalizarCampaign (camp) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea finalizar la campaña "' + camp.name + '"?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.$http.post('/api/admin/campaign/deactivate/' + camp._id).then(({body}) => {
          camp.activo = false
        }, (err) => {
          console.log(err)
        })
      }, (dismiss) => {
        return false
      })
    },
    cancelarCampaign (camp) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea Cancelar la campaña "' + camp.name + '"?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.$http.post('/api/admin/campaign/cancel/' + camp._id).then(({body}) => {
          me.cargar()
        }, (err) => {
          console.log(err)
        })
      }, (dismiss) => {
        return false
      })
    },
    cargar () {
      const me = this
      me.loading = true
      me.$http.get('/api/admin/campaigns', {page: me.page, offset: me.offset}).then(({body}) => {
        me.campaigns = body.campaigns
        me.loading = false
      }, (err) => {
        me.loading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    }
  },
  mounted () {
    const me = this
    me.cargar()
  },
  watch: {
  }
}
</script>
<style scoped>
.modal {
  background-color: white;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #F28893;
  color: #333;
}
.status-cocina {
  background-color: #FFC182;
  color: #333;
}
.status-empaquetado {
  background-color: #74A9B3;
  color: #333;
}
.status-entregado {
  background-color: #93A512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// Campaigns.vue?63493c7b